import { FC } from "react";
import {
  Box,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import customFilterStyles from "./customFiltersStyles";

type SearchComponentParams = {
  t: (arg0: string) => string;
  quickFilterValue: string;
  handleQuickFilterChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const SearchComponent: FC<SearchComponentParams> = ({
  t,
  quickFilterValue,
  handleQuickFilterChange,
}) => {
  return (
    <Box sx={customFilterStyles.searchComponentContainer}>
      <FormControl
        id="input-filter-position-us"
        sx={customFilterStyles.SearchComponent}
        size="small"
        variant="outlined"
      >
        <InputLabel htmlFor="outlined-adornment-password">
          {t("Common_options.type_to_search")}
        </InputLabel>
        <OutlinedInput
          endAdornment={
            <InputAdornment position="end">
              <IconButton>
                <SearchIcon />
              </IconButton>
            </InputAdornment>
          }
          value={quickFilterValue}
          onChange={handleQuickFilterChange}
          label={t("Common_options.type_to_search")}
        />
      </FormControl>
    </Box>
  );
};

export default SearchComponent;
